import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useSelector } from "react-redux";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ToastModal from "views/components/ToastModal";

const useStyles = makeStyles({
  Notification: {
    position: "relative",
    padding: 0,
    margin: 0,
    background: "transparent",
    display: "flex",
    alignItems: "center",
  },

  notificationWrapper: {
    position: "relative",
    cursor: "pointer",
    padding: "0px",
  },

  bell: {
    fontSize: "22px",
  },

  badge: {
    position: "absolute",
    top: "-4px",
    right: "-6px",
    color: "#000000",
    padding: "1px 5px",
    borderRadius: "50%",
    fontSize: "15px",
  },

  dropdown: {
    position: "absolute",
    top: "30px",
    right: "0px",
    width: "300px",
    maxHeight: "300px",
    overflowY: "auto",
    background: "#fff",
    border: "1px solid #ddd",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
    zIndex: 100,
  },

  empty: {
    padding: "15px",
    textAlign: "center",
    color: "#777",
  },

  notificationItem: {
    padding: "12px",
    cursor: "pointer",
    borderBottom: "1px solid #f2f2f2",
    "&:hover": {
      background: "#f8f8f8",
    },
  },

  unread: {
    background: "#e9f3ff",
    fontWeight: "bold",
  },

  read: {
    background: "#fff",
  },
});

const Notification = ({ notifications = [], setNotifications }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);
  const { authToken } = useSelector((state) => state.login.authData);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
    const [callInProgress, setCallInProgress] = useState(false);
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const unreadCount = notifications?.filter((n) => !n.read)?.length;
  const updateReadNotificaiton = async (notificationid) => {
    setCallInProgress(true)
      const result = await apiHandler({
          url: `${endpoint.UPDATE_WEB_SOCKET_NOTIFICATION_STATUS}${notificationid}/read`,
          authToken: authToken,
          method: "PATCH",
        });
        if(result?.data?.error_code){
        toastUpdate("Error",result?.data?.user_description,true);
      }else{
        getMessageNotification();
      }
  }

      const getMessageNotification = async ( ) => {
        const result = await apiHandler({
          url: endpoint.GET_WEB_SOCKET_NOTIFICATION ,
          authToken: authToken,
        });
            setCallInProgress(false)
        if(result?.data?.error_code){
          toastUpdate("Error",result?.data?.user_description,true);
        }else{
          const losNotifications = result?.data?.filter((item) => item.module === "LOS" && !item?.read)
          setNotifications(losNotifications);
        }
      };
  // ✅ CLICK OUTSIDE HANDLER
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpen(false); // close dropdown
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className={classes.Notification} ref={wrapperRef}>
      {/* Bell + Badge */}
      <div
        className={classes.notificationWrapper}
        onClick={() => setOpen(!open)}
      >
        <span className={classes.bell}>🔔</span>

        {unreadCount > 0 && (
          <span className={classes.badge}>{unreadCount}</span>
        )}
      </div>

      {/* Dropdown */}
      {open && (
        <div className={classes.dropdown}>
          {notifications?.length === 0 && (
            <div className={classes.empty}>No notifications</div>
          )}

          {notifications?.map((n) => (
            <div
              key={n.id}
              className={`${classes.notificationItem} ${
                n.read ? classes.read : classes.unread
              }`}
              onClick={() => updateReadNotificaiton(n.id)}
            >
              {n.message}
            </div>
          ))}
        </div>
      )}
      {toast && (
                <ToastModal
                  toastMessage={toastMessage}
                  toastMessageType={toastMessageType}
                  toastUpdate={toastUpdate}
                />
              )}
                    {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </div>
  );
};

export default Notification;
